import React, { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './Contact.css';

gsap.registerPlugin(ScrollTrigger);

const Contact: React.FC = () => {
  const [form, setForm] = useState({ name: '', email: '', service: '', message: '' });

  useEffect(() => {
    gsap.fromTo('.contact-title',
      { y: 60, opacity: 0 },
      { y: 0, opacity: 1, duration: 1, ease: 'power3.out',
        scrollTrigger: { trigger: '.contact-title', start: 'top 80%' } }
    );
    gsap.fromTo('.contact-form-wrap',
      { y: 60, opacity: 0 },
      { y: 0, opacity: 1, duration: 1, ease: 'power3.out', delay: 0.2,
        scrollTrigger: { trigger: '.contact-form-wrap', start: 'top 85%' } }
    );
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    alert('Messaggio inviato! Ti risponderemo presto.');
    setForm({ name: '', email: '', service: '', message: '' });
  };

  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="contact-inner">
          <div className="contact-left">
            <div className="section-header contact-title">
              <span className="section-tag">— Parlaci del tuo progetto</span>
              <h2 className="section-title">
                Inizia il tuo <span className="highlight">progetto</span>
              </h2>
            </div>
            <div className="contact-info">
              <div className="contact-item">
                <span className="contact-icon">◉</span>
                <div>
                  <span className="contact-label">Email</span>
                  <span className="contact-value">info@kromaker.it</span>
                </div>
              </div>
              <div className="contact-item">
                <span className="contact-icon">◈</span>
                <div>
                  <span className="contact-label">Sede</span>
                  <span className="contact-value">Italia</span>
                </div>
              </div>
            </div>
          </div>

          <div className="contact-form-wrap">
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label>Nome</label>
                  <input
                    type="text"
                    placeholder="Il tuo nome"
                    value={form.name}
                    onChange={e => setForm({...form, name: e.target.value})}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Email</label>
                  <input
                    type="email"
                    placeholder="tua@email.com"
                    value={form.email}
                    onChange={e => setForm({...form, email: e.target.value})}
                    required
                  />
                </div>
              </div>
              <div className="form-group">
                <label>Servizio richiesto</label>
                <select value={form.service} onChange={e => setForm({...form, service: e.target.value})} required>
                  <option value="">Seleziona un servizio</option>
                  <option>Stampa 3D</option>
                  <option>Incisione Laser</option>
                  <option>Stampa UV</option>
                  <option>Sviluppo Tech</option>
                  <option>Design Digitale</option>
                  <option>Prototipazione</option>
                  <option>Altro</option>
                </select>
              </div>
              <div className="form-group">
                <label>Messaggio</label>
                <textarea
                  placeholder="Descrivi il tuo progetto..."
                  rows={5}
                  value={form.message}
                  onChange={e => setForm({...form, message: e.target.value})}
                  required
                />
              </div>
              <button type="submit" className="btn-primary submit-btn">
                Invia messaggio →
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
